import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: center;
`;

export const FullHeightContainer = styled(Container)`
  height: 100%;
  align-items: center;
`;
